module.exports = __webpack_public_path__ + "static/blog2-dc689a21dd8663f4ebceda27f6733394.mp4";